import React from "react";


import Navbar from "./Components/Navbar";
import About from "./Components/About";
import Education from "./Components/Education";
import Skills from "./Components/Skills";
import Intrests from "./Components/Intrests";
import Project from "./Components/project";
import Experience from "./Components/Experience";
import Freelancer from "./Components/Freelancer";


import "./css/style.css";
import "./css/navbar.css";

const App = () => {
    return(
        <div>
            <Navbar/>
            <About/>
            <Experience/>
            <Freelancer/>
            <Project/>
            <Education/>
            <Skills/>
            <Intrests/>
        </div>
    )
}

export default App;